const INVITE_STATE_PREFIX = 'invite_signup:';
const INVITE_SIGNUP_FLAG_KEY = 'prism_invite_signup_complete';

const getParamsFromLocation = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  const hash = window.location.hash ? window.location.hash.replace(/^#/, '') : '';
  if (hash) {
    return new URLSearchParams(hash);
  }
  const search = window.location.search ? window.location.search.replace(/^\?/, '') : '';
  return search ? new URLSearchParams(search) : null;
};

export const markInviteSignupFromLocation = (options = {}) => {
  const params = getParamsFromLocation();
  if (!params) {
    return false;
  }
  if (params.get('error')) {
    return false;
  }
  const state = params.get('state');
  if (!state || !state.startsWith(INVITE_STATE_PREFIX)) {
    return false;
  }
  sessionStorage.setItem(INVITE_SIGNUP_FLAG_KEY, '1');
  if (typeof window !== 'undefined') {
    const targetPath = options.redirectPath || window.location.pathname;
    window.history.replaceState(null, document.title, `${targetPath}${window.location.search}`);
  }
  return true;
};

export const consumeInviteSignupFlag = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  const flag = sessionStorage.getItem(INVITE_SIGNUP_FLAG_KEY);
  if (flag !== '1') {
    return false;
  }
  sessionStorage.removeItem(INVITE_SIGNUP_FLAG_KEY);
  return true;
};
